import { Link, Text } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import { messages } from './ConsentInfo.messages';
import { ConsentInfoProps } from './ConsentInfo.types';

export const ConsentInfo: FC<ConsentInfoProps> = memo((props) => {
    const { buttonText } = props;

    return (
        <Text font='body' color='midnight70' fontSize='small' textAlign='center'>
            {messages.description({
                buttonText,
                br: <br />,
                terms: (text: string) => (
                    <Link font='body' external href='https://www.approvalmax.com/terms'>
                        {text}
                    </Link>
                ),
                policy: (text: string) => (
                    <Link font='body' external href='https://www.approvalmax.com/policy'>
                        {text}
                    </Link>
                ),
            })}
        </Text>
    );
});

ConsentInfo.displayName = 'ConsentInfo';
